"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useSynthesize;

var _react = require("react");

var _Context = _interopRequireDefault(require("./Context"));

var _createNativeUtterance = _interopRequireDefault(require("./createNativeUtterance"));

function useSynthesize() {
  var _useContext = (0, _react.useContext)(_Context["default"]),
      ponyfill = _useContext.ponyfill,
      synthesize = _useContext.synthesize;

  return function (utteranceOrText, progressFn) {
    if (typeof utteranceOrText === 'string') {
      utteranceOrText = (0, _createNativeUtterance["default"])(ponyfill, {
        text: utteranceOrText
      });
    }

    return synthesize(ponyfill, utteranceOrText, {
      onStart: progressFn && function () {
        return progressFn();
      }
    });
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy91c2VTeW50aGVzaXplLmpzIl0sIm5hbWVzIjpbInVzZVN5bnRoZXNpemUiLCJDb250ZXh0IiwicG9ueWZpbGwiLCJzeW50aGVzaXplIiwidXR0ZXJhbmNlT3JUZXh0IiwicHJvZ3Jlc3NGbiIsInRleHQiLCJvblN0YXJ0Il0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQTs7QUFFQTs7QUFDQTs7QUFFZSxTQUFTQSxhQUFULEdBQXlCO0FBQ3RDLG9CQUFpQyx1QkFBV0MsbUJBQVgsQ0FBakM7QUFBQSxNQUFRQyxRQUFSLGVBQVFBLFFBQVI7QUFBQSxNQUFrQkMsVUFBbEIsZUFBa0JBLFVBQWxCOztBQUVBLFNBQU8sVUFBQ0MsZUFBRCxFQUFrQkMsVUFBbEIsRUFBaUM7QUFDdEMsUUFBSSxPQUFPRCxlQUFQLEtBQTJCLFFBQS9CLEVBQXlDO0FBQ3ZDQSxNQUFBQSxlQUFlLEdBQUcsdUNBQXNCRixRQUF0QixFQUFnQztBQUFFSSxRQUFBQSxJQUFJLEVBQUVGO0FBQVIsT0FBaEMsQ0FBbEI7QUFDRDs7QUFFRCxXQUFPRCxVQUFVLENBQUNELFFBQUQsRUFBV0UsZUFBWCxFQUE0QjtBQUFFRyxNQUFBQSxPQUFPLEVBQUVGLFVBQVUsSUFBSztBQUFBLGVBQU1BLFVBQVUsRUFBaEI7QUFBQTtBQUExQixLQUE1QixDQUFqQjtBQUNELEdBTkQ7QUFPRCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IHVzZUNvbnRleHQgfSBmcm9tICdyZWFjdCc7XG5cbmltcG9ydCBDb250ZXh0IGZyb20gJy4vQ29udGV4dCc7XG5pbXBvcnQgY3JlYXRlTmF0aXZlVXR0ZXJhbmNlIGZyb20gJy4vY3JlYXRlTmF0aXZlVXR0ZXJhbmNlJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gdXNlU3ludGhlc2l6ZSgpIHtcbiAgY29uc3QgeyBwb255ZmlsbCwgc3ludGhlc2l6ZSB9ID0gdXNlQ29udGV4dChDb250ZXh0KTtcblxuICByZXR1cm4gKHV0dGVyYW5jZU9yVGV4dCwgcHJvZ3Jlc3NGbikgPT4ge1xuICAgIGlmICh0eXBlb2YgdXR0ZXJhbmNlT3JUZXh0ID09PSAnc3RyaW5nJykge1xuICAgICAgdXR0ZXJhbmNlT3JUZXh0ID0gY3JlYXRlTmF0aXZlVXR0ZXJhbmNlKHBvbnlmaWxsLCB7IHRleHQ6IHV0dGVyYW5jZU9yVGV4dCB9KTtcbiAgICB9XG5cbiAgICByZXR1cm4gc3ludGhlc2l6ZShwb255ZmlsbCwgdXR0ZXJhbmNlT3JUZXh0LCB7IG9uU3RhcnQ6IHByb2dyZXNzRm4gJiYgKCgpID0+IHByb2dyZXNzRm4oKSkgfSk7XG4gIH07XG59XG4iXX0=